const cutTx = (tx: string)=> {
    if (tx == null) {
        return "n/a"
    }
    return tx.substr(2, 4) + "...." + tx.substr(tx.length - 4, 4)
}

export default cutTx
